import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 340 375"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M9.86 4.832C1.78 7.023.253 11.18.253 17.07c0 1.938-1.938 112.758-1.961 196.45v.921c0 40.829 7.852 61.98 17.64 79.625 29.262 50.848 80.087 77.914 148.438 77.914h1.941c68.54 0 121.098-27.296 150.145-77.914 9.816-17.46 17.668-38.796 17.668-79.625 0-83.73-1.965-193.906-1.965-197.808 0-5.89-3.695-10.278-9.398-11.801-5.633-1.523-20.067-3.258-39.465-3.258-21.406 0-38.84 1.524-44.75 3.489-7.852 1.73-7.852 11.57-7.852 11.57 1.961 68.262 0 182.105 0 191.941 0 41.016-29.257 62.399-66.324 62.399-37.129 0-66.367-21.383-66.574-62.399 0-9.605.207-125.207.207-193.488 0 0 0-6.77-9.813-10.023-5.453-1.965-17.664-3.903-39.28-3.903-17.692 0-30.993 1.27-39.052 3.672"
    }, null, -1)
  ])))
}
export default { render: render }